{
  "greeting": "Buenos días",
  "welcome": "Dez Inglés"
}
